import {
    Table,
    TableBody,
} from '@/src/shadComponents/ui/table';

export default function HeadlessTable({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <div className="rounded-md border">
            <Table>
                <TableBody>{children}</TableBody>
            </Table>
        </div>
    );
}
